import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import {
    CreateTransactionTimer,
    TransactionTimer,
    TransactionTimerListResponse,
    TransactionTimerQueryParams,
    UpdateTransactionTimer
} from '@frontend/transaction/types';

export class TransactionTimerClient extends APIClient {
    public static readonly endpoint = '/transaction-api/v1';

    public static async fetchTimers(queryParams?: ApiQueryParams<TransactionTimerQueryParams>): Promise<TransactionTimerListResponse> {
        return await this.apiPaginated<TransactionTimerListResponse, TransactionTimerQueryParams>(`${this.endpoint}/timers`, queryParams);
    }

    public static async fetchStartedTimers(queryParams?: ApiQueryParams<TransactionTimerQueryParams>): Promise<TransactionTimerListResponse> {
        return await this.apiPaginated<TransactionTimerListResponse, TransactionTimerQueryParams>(`${this.endpoint}/started-timers`, queryParams);
    }

    public static async fetchCompletedTimers(queryParams?: ApiQueryParams<TransactionTimerQueryParams>): Promise<TransactionTimerListResponse> {
        return await this.apiPaginated<TransactionTimerListResponse, TransactionTimerQueryParams>(`${this.endpoint}/completed-timers`, queryParams);
    }

    public static async fetchAccountTransactionTimers(
        accountId: string,
        transactionId: string,
        queryParams?: ApiQueryParams<TransactionTimerQueryParams>
    ): Promise<TransactionTimerListResponse> {
        return await this.apiPaginated<TransactionTimerListResponse, TransactionTimerQueryParams>(
            `${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/timers`,
            queryParams
        );
    }

    public static async fetchAccountTransactionTimer(accountId: string, transactionId: string, timerId: string): Promise<TransactionTimer> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/timers/${timerId}`);
        return await this.handleResponse<TransactionTimer>(response);
    }

    public static async postAccountTransactionTimer(accountId: string, transactionId: string, body: CreateTransactionTimer): Promise<TransactionTimer> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/timers`, body);
        return await this.handleResponse<TransactionTimer>(response);
    }

    public static async patchAccountTransactionTimer(
        accountId: string,
        transactionId: string,
        timerId: string,
        body: UpdateTransactionTimer
    ): Promise<TransactionTimer> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/timers/${timerId}`, body);
        return await this.handleResponse<TransactionTimer>(response);
    }

    public static async deleteAccountTransactionTimer(accountId: string, transactionId: string, timerId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/timers/${timerId}`);
        await this.handleVoidResponse(response);
    }
}
